'use strict';

const _ = require('lodash');

const auth = require('./services/auth');
const help = require('./services/help');
const container = require('./core/container');
const translator = require('./core/translator');

const PageRepository = require('./bundles/page/repository/page');

let events = {
  'global': {
    'application:ready': [
      {'callback': require('./services/flashMessage').flash},
      {'callback': require('./services/flashMessage').flashCallback},
      {'callback': require('./services/structure').init},
    ],
    'config:ready': [
      {'callback': auth.init.bind(auth)},
    ],
    'on:change:locale': [
      {'callback': require('./core/translator').setLocale},
    ],
    'panels:close': [
      {'callback': require('./services/structure/menu/desktop').unFocus},
    ],
    'structure:ready': [
      {'callback': require('./services/structure/menu').init},
      {'callback': require('./services/structure/zone').init},
      {'callback': require('./services/rte').init},
      {'callback': require('./services/windowResize').init},
      {'callback': require('./services/checkContainer').init},
    ],
    'menu:close': [
      {'callback': require('./services/structure/zone').hidePanels},
    ],
    'request:send:before': [
      {'callback': auth.beforeRequestSend.bind(auth)},
    ],
    'request:send:fail': [
      {'callback': auth.onRequestFail.bind(auth)},
    ],
    'menu:my_account:logout:click': [
      {
        'callback': function(param) {
          if (param.popin) {
            param.popin.hide();
          }

          require('./services/auth').logout(true);
        },
      },
    ],
    'menu:about-page:click': [
      {'callback': require('./services/about').init},
    ],
    'menu:debug-page:click': [
      {'callback': require('./services/debug').init},
    ],
    'menu:help-center:click': [
      {'callback': help.onGlobalMenuClick},
    ],
    'menu:more-parameters:click': [
      {'callback': require('./services/structure/menu/panel').init.bind(undefined, 'more-parameters', 'setSmallPanel')},
    ],
    'window:resize': [
      {'callback': require('./services/checkContainer').check},
    ],
    'show:overlay': [
      {'callback': require('./services/overlay').show},
    ],
    'overlay:hide': [
      {'callback': require('./services/overlay').hide},
    ],
    'ui-enabled': [
      {
        'callback': function() {
          container.set('ui_status', 'enabled');
        },
      },
    ],
    'ui-disabled': [
      {
        'callback': function() {
          container.set('ui_status', 'disabled');
        },
      },
    ],
    'ui-insert-content-disabled': [
      {
        'callback': function() {
          container.set('ui_insert_content', 'disabled');
        },
      },
    ],
    'ui-enable-dnd-only-horizontal-between-content': [
      {
        'callback': function() {
          container.set('ui-enable-dnd-only-horizontal-between-content', true);
        },
      },
    ],
  },
  'desktop': {
    'menu:ready': [
      {
        'callback': function(add) {
          let $toolbar = container.get('$toolbar');
          if (container.get('page.uid') && container.get('isAllowedTo')('PUBLISH_PAGE')) {
            PageRepository.find($toolbar.data('page-uid')).done((page) => {
              add(translator.translate('save'), 'play', 1, 'publish', 'btn-publish', undefined, undefined, 'submit');
              add(translator.translate('discard'), 'cancel', 10, 'cancel', 'btn-cancel', undefined, undefined, 'submit');
            });
          } else {
            if (container.get('page.uid') && (container.get('isAllowedTo')('CREATE_CONTENT') || container.get('isAllowedTo')('EDIT_CONTENT') || container.get('isAllowedTo')('DELETE_CONTENT'))) {
              PageRepository.find($toolbar.data('page-uid')).done((page) => {
                if (!page['is_online']) {
                  add(translator.translate('save'), 'play', 1, 'publish', 'btn-publish', undefined, undefined, 'submit');
                  add(translator.translate('discard'), 'cancel', 10, 'cancel', 'btn-cancel', undefined, undefined, 'submit');
                }
              });
            }
          }

          add(translator.translate(container.get('page.uid') ? 'page_parameters_form_online' : 'error_404'), undefined, 11, 'page-online-switch', 'online-switch', undefined, undefined, 'submit');

          if (container.get('page.uid') && (container.get('isAllowedTo')('SEO_TRACKING_FEATURE') || container.get('isAllowedTo')('TAG_FEATURE') || container.get('isAllowedTo')('MULTILANG_FEATURE') || container.get('isAllowedTo')('CUSTOM_DESIGN_FEATURE') || container.get('isAllowedTo')('PRIVACY_POLICY_FEATURE') || container.get('isAllowedTo')('BUNDLE_MEDIACENTER_FEATURE'))) {
            add(translator.translate('more-parameters'), 'more-parameters', 60, 'more-parameters');
          }
          add(translator.translate('help'), 'question', 100, 'help-center', undefined, undefined, undefined, 'secondary');

          if (container.get('current_user_is_super_admin')) {
            add(translator.translate('about'), 'about', 100, 'about-page', undefined, undefined, undefined, 'secondary');
            add(translator.translate('debug'), 'debug', 100, 'debug-page', undefined, undefined, undefined, 'secondary');
          }
          add(translator.translate('my_account'), 'user', 100, 'my_account', 'btn-my-account', undefined, undefined, 'secondary');
        },
      },
    ],
    'connected': [
      {'callback': require('./bundles/user/service/handlePermissions').init},
    ],
    'overlay:click': [
      {'callback': require('./services/popin/popin/events').onOverlayClick},
    ],
    'menu:help:click': [
      {'callback': require('./services/help').onMenuClick},
    ],
    'on:popin:open': [
      {'callback': require('./services/structure/menu').hide},
      {'callback': require('./services/overlay').show},
    ],
    'on:popin:close': [
      {'callback': require('./services/structure/menu').show},
      {'callback': require('./services/overlay').hide},
    ],
  },
  'mobile': {
    'menu:ready': [
      {
        'callback': function(add) {
          add(translator.translate('publish'), 'play', 1, 'publish', 'btn-publish');
          add(translator.translate('discard'), 'undo', 10, 'cancel', 'btn-cancel');
          add(translator.translate('more-parameters'), 'more-parameters', 60, 'more-parameters');
          add(translator.translate('my_account'), 'user', 90, 'my_account', 'btn-my-account', undefined, undefined, 'secondary');
        },
      },
    ],
    'connected': [
      {'callback': require('./bundles/user/service/handlePermissions').init},
      {
        'callback': function() {
          window.oncontextmenu = function() {
            return false;
          };
        },
      },
    ],
  },
};
module.exports = {
  'bundles': {
    'page': require('./bundles/page/config'),
    'content': require('./bundles/content/config'),
    'tags': require('./bundles/tag/config'),
    'user': require('./bundles/user/config'),
    'bundle': require('./bundles/bundle/config'),
    'design': require('./bundles/design/config'),
  },
  'events': _.merge(events.global, events[container.get('isMobile') ? 'mobile' : 'desktop']),
};
